import { loadTFJSModelFromDB } from "../utils/utils";

export class DocumentQuality{
    constructor() {
        return (async () => {
            this.config = await this.loadConfig();
            this.model = await this.loadModel(); 
            this.allowed_classes = this.config["CLASSES"];
            this.id_to_class = {
                0: "bad",
                1: "good"
            }
            this.goodCentroid = null;
            this.badCentroid = null;
            await this.loadCentroids(); 
            this.hasError = false;
            this.errorMessage = "";
            return this;
        })();
    }
    async loadCentroids(){
        const centroidData = await fetch("../configs/centroids_val.json").then(r => r.json());  
        const goodCentroid = window.tf.tensor1d(centroidData.good);
        const badCentroid = window.tf.tensor1d(centroidData.bad);
        this.goodCentroid = goodCentroid;
        this.badCentroid = badCentroid;
    }
    checkModelisLoaded(){
        if(this.model != undefined){
            return true;
        }else{
            return false;
        }
    }
    async loadConfig(){
        return fetch("../configs/configs.json").then((res)=>{
            return res.json();
        }).then((data)=>{
            return data;
        }).catch((err)=>{
            console.error(err)
        });

    }

    async loadModel(){
        try{
            if (this.checkModelisLoaded()){
                return this.model;
            }
            const [model_json,model_weight] = await loadTFJSModelFromDB(this.config["URLS"]["QUALITY_MODEL_JSON"],this.config["URLS"]["QUALITY_MODEL_WEIGHT"],"QUALITY_MODEL_JSON","QUALITY_MODEL_WEIGHT")
            
            let mw1 = new File([model_weight], "group1-shard1of1.bin");
            let uint8Array = new Uint8Array(model_json);

            const decoder = new TextDecoder('utf-8');
            const string1 = decoder.decode(uint8Array);
            let mj1 = new File([string1], "model.json", {
                type: "application/json",
            });

            let model = await window.tf.loadGraphModel(
               window.tf.io.browserFiles([mj1,mw1])
            )
            return model; 
        }catch(error){
            console.log(error)
            this.hasError = true;
        }
        
    }
    preProcess(img){
        const norm_img = window.tf.tidy(()=>{
            img = window.tf.image.resizeBilinear(img, [this.config["INPUTS"]["QUALITY_INPUT_HEIGHT"], this.config["INPUTS"]["QUALITY_INPUT_WIDTH"]])
            img = img.div(255.0);
            const mean = window.tf.tensor1d([0.485, 0.456, 0.406]);
            const std = window.tf.tensor1d([0.229, 0.224, 0.225]);
            const normalized = img.sub(mean).div(std);
            return normalized.expandDims(0); 
        });
        return norm_img;
    }
    cosineSimilarity(a, b) {
        // if (!a || !b) throw new Error("Tensor is null in cosineSimilarity");
        return window.tf.tidy(() => {
          const dot = window.tf.sum(window.tf.mul(a, b));
          const normA = window.tf.norm(a);
          const normB = window.tf.norm(b);
          return dot.div(normA.mul(normB));
        });
      }  
    softmax(arr) {
      const max = Math.max(...arr);
      const exps = arr.map(x => Math.exp(x - max));
      const sum = exps.reduce((a, b) => a + b);
      return exps.map(v => v / sum);
    }

    async predict(image){
        this.hasError=false;
        this.errorMessage="";
       window.tf.engine().startScope();
        let image_tensor =window.tf.browser.fromPixels(image).toFloat() ;
        image_tensor = window.tf.reverse(image_tensor, -1);
        image_tensor = this.preProcess(image_tensor);
        const output = await this.model.execute(image_tensor); 
        let simGood = this.cosineSimilarity(output, this.goodCentroid).dataSync()[0];
        let simBad = this.cosineSimilarity(output, this.badCentroid).dataSync()[0];
        const probs = this.softmax([simBad,simGood ]);
        
        if(simGood < 0 ){
            simGood = 0;
            simGood = (1-probs[1]) + 0.50
        }
        if (simGood > 1 ){
            simGood = 1;
        }
        if(simBad < 0 ){
            simBad = 0;
            simBad = (1-probs[0]) + 0.50
        }
        if (simBad > 1 ){
            simBad = 1 ;
        }
        const label = probs[0] > probs[1] ? "bad" : "good";
        const score = probs[0] > probs[1] ? simBad : simGood;
        if(this.hasError){
           window.tf.engine().endScope();
            return [null,null,this.hasError,this.errorMessage];
        }else{
            // document.body.appendChild(largest_vehicle.vehicle);
        }
       window.tf.engine().endScope();
        return [label,score,this.hasError,this.errorMessage];
    }

}

